import { Component } from "react";
import $ from "jquery";
import { Segment, Button, Form } from "common-components";

import { validEmail } from "../../Common/helpers/validations";

import FormError from "./FormError";
import { TextInput, HeaderText } from "./Login";

class ForgotPassword extends Component {
  state = {
    email: "",
    loading: false,
    resetSuccess: false,
    showError: false,
    error: "",
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    return $.ajax({
      url: "/users/password",
      type: "POST",
      dataType: "json",
      data: { user: { email: this.state.email } },
    })
      .then(() => {
        this.setState({
          loading: false,
          resetSuccess: true,
          error: "",
        });
      })
      .catch(({ responseText }) => {
        const {
          errors: { email },
        } = JSON.parse(responseText);
        const [errorMessage] = email;
        this.setState({
          loading: false,
          showError: true,
          error:
            errorMessage === "not found" ? "Email not found" : errorMessage,
        });
      });
  };

  render() {
    const { loading, error, resetSuccess, email, showError } = this.state;

    return (
      <Segment className="login forgot-password">
        <HeaderText textAlign="center" as="h2">
          {resetSuccess ? "Almost done..." : "Reset your password"}
        </HeaderText>

        <FormError error={error} />

        {!resetSuccess && (
          <p>
            Enter the email address you use to log in and we'll send you
            instructions on how to reset your password.
          </p>
        )}

        {!resetSuccess ? (
          <Form onSubmit={this.handleSubmit}>
            <Form.Input
              control={TextInput}
              value={this.state.email}
              onChange={(e, { value }) =>
                this.setState({ email: value, showError: false })
              }
              name="email"
              placeholder="Email"
              fluid
              error={error.length > 0 && showError}
              autoFocus
            />

            <Button
              loading={loading}
              type="submit"
              fluid
              className="primary"
              disabled={!validEmail(email) || loading}
            >
              Reset my password
            </Button>
          </Form>
        ) : (
          <p>
            If an account with that email exists you will receive a link to
            reset your password shortly.
          </p>
        )}
      </Segment>
    );
  }
}

export default ForgotPassword;
